import { render, staticRenderFns } from "./MoveFolder.vue?vue&type=template&id=651122d5"
import script from "./MoveFolder.vue?vue&type=script&lang=js"
export * from "./MoveFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports